module.exports = __webpack_public_path__ + "static/media/placement.14387233.svg";